var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4678 1.09262C20.4239 2.69249 15.2353 14.9942 12.8241 20.9999C14.3624 17.3102 20.7513 8.72783 23.8176 9.24242C28.991 9.40707 36.8402 23.6624 40 30.8376C38.0473 26.1301 36.0339 19.9649 32.7929 14.6184C29.5517 9.27202 25.115 2.148 23.4678 1.09262Z",
    fill: "#CB3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6792 38.3837C37.0002 34.7359 29.9967 23.5385 26.5143 18.185C28.624 21.5268 32.0702 31.9001 30.0699 34.4691C27.2496 39.1694 11.9253 39.0173 4.62343 38.2092C9.35153 38.8509 15.2609 40.1942 21.1627 39.9764C27.0645 39.7583 34.9903 39.3586 36.6792 38.3837Z",
    fill: "#CB3939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 30.5494C2.82054 32.5734 15.2388 31.1514 21.2392 30.3435C17.5238 30.7866 7.4511 29.1969 6.2999 26.0764C3.79829 21.169 11.1351 6.59718 15.2304 0C12.4822 4.21601 8.60629 9.23044 6.00596 14.9727C3.40563 20.7151 0.000770291 28.4768 0 30.5494Z",
    fill: "#CB3939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaml);
export default __webpack_public_path__ + "static/media/saml.1a68c1e046fc1615b700f6e71c659acc.svg";
export { ForwardRef as ReactComponent };